import React, { Component, useState,useRef } from "react";
import { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Polygon,
  Marker,
  useMapEvents,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import axios from "axios";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
// import * as L from 'react-leaflet';

// var polygonCoords = [
//     [12.930280,77.676136],
//     [12.931760,77.684723],
//     [12.926055,77.685756],
//     [12.927615,77.679781],
//   ];
var vikki = [];
var Saved = [];
function AddMarkerToClick(props) {
  const [markers, setMarkers] = useState([]);
  const [status, setStatus] = useState(false);

  const [polyChords, setPolyChords] = useState([]);

  useEffect(()=>{
    let marker=[]
props.polyChords.map((val)=>{
    setStatus(false);
    vikki.push([val[0], val[1]]);
    Saved.push({ Lat: val[0], Lng: val[1]});
    setPolyChords(vikki);
    const newMarker = { lat: val[0], lng: val[1]};
    marker.push(newMarker)
    ;
})
setMarkers(marker)
  },[])
  const map = useMapEvents({
    click(e) {
      if (!status) {
        setStatus(false);

        vikki.push([e.latlng.lat, e.latlng.lng]);
        Saved.push({ Lat: e.latlng.lat, Lng: e.latlng.lng });
        setPolyChords(vikki);
        const newMarker = e.latlng;
        setMarkers([...markers, newMarker]);
      }
    },
  });

  function createPolyGon() {
    console.log('saved',Saved)
    setStatus(true);
    props.setDisableStatus(true)
  }

  function clearAllMarkers() {
    props.setDisableStatus(false)
    setMarkers([]);
    setPolyChords([]);
    vikki = [];
    Saved = [];
    setStatus(false);
  }
  function MyButton() {
    const map = useMap();

    const handleClick = () => {
      // Do something when the button is clicked
      console.log("clicked");
      clearAllMarkers();
    };

    useEffect(() => {
      const container = L.DomUtil.create(
        "div",
        "leaflet-bar leaflet-control leaflet-control-custom"
      );

      container.innerHTML =
        '<button  class="mapButton" type="button">Clear Polygon</button>';
      container.onclick = handleClick;

      L.DomEvent.disableClickPropagation(container);
      map
        .getContainer()
        .querySelector(".leaflet-bottom.leaflet-left ")
        .appendChild(container);

      return () => {
        // Clean up the button when the component is unmounted
        container.remove();
      };
    }, [map, handleClick]);

    return null;
  }
  return (
    <>
      <MyButton />
      {markers.map((marker, i) => (
        <Marker position={marker}>
          {polyChords.length !== 0 && (
            <>
              {status ? (
                <Polygon positions={polyChords} fillOpacity={0.09} />
              ) : (
                <Polyline positions={polyChords} />
              )}
            </>
          )}

          {i === 0 && (
            <Popup>
              <div style={{ cursor: "pointer", color: "blue" }}>
                {status ? (
                  <div onClick={() => {}}>Create Geofence</div>
                ) : (
                  <>
                    {markers.length <= 2 ? (
                      <div>Points Should be more than 2</div>
                    ) : (
                      <div onClick={createPolyGon}>
                        click here to create polygon
                      </div>
                    )}
                  </>
                )}
              </div>
            </Popup>
          )}
        </Marker>
      ))}
    </>
  );
}

export default function UpdatePolyLine(props) {
  const [disableStatus, setDisableStatus] = useState(false);
  const mapRef = useRef(null);
  const [polyChords, setPolyChords] = useState([]);
  function updateGeofence() {
    let geofenceDetails = {
        geofenceLatLng:Saved
    };
    axios
      .put(Baseurl.baseurl + `/health/update-geofence-main/${props.location.state.item._id}`, geofenceDetails)
      .then((res) => {
        if (res.data.status) {
          swal("Updated", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  useEffect(()=>{
    let latLng=[]
    props.location.state.item.GeofenceLatLng.map((val)=>{
        latLng.push([val.Lat,val.Lng])
    })
    setPolyChords(latLng)
 },[])
  return (
    <>
      <div>
        {polyChords.length!==0&&(
             <MapContainer
             bounds={polyChords}
             ref={mapRef}
             style={{
               height: window.innerHeight / 1.6,
               width: window.innerWidth / 1.4,
               position: "fixed",
               top: "210px",
             
             }}
            
             scrollWheelZoom={true}
         >
           <AddMarkerToClick setDisableStatus={setDisableStatus} polyChords={polyChords} />
 
           <TileLayer
        url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        maxZoom={21}
        minZoom={4}
        minZoomIsDrawing={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
         </MapContainer>
        )}
       
      </div>
      {disableStatus&&(
         <div
         style={{ position: "fixed", top: "130px", zIndex: 10 }}
         className="form-group row"
       >
        
 
         <div className="col-sm-2">
           <button
             onClick={() => {
               updateGeofence();
             }}
             className="btn btn-primary p-2 mt-3"
            
           >
             Update
           </button>
         </div>
       </div>
      )}
     
    </>
  );
}
